import Select from "@/components/common/form/select";
import Input from "@/components/common/form/input";
import Button from "@/components/common/form/button";
import { useSwrGet } from "@/utils/use-swr-get";
import Textarea from "@/components/common/form/textarea";
import { authServices } from "services/auth.services";
import Loader from "@/components/common/loader.components";
import { useTranslation } from "react-i18next";

function cameraForm({ icon, passProps, ...props }) {
  const { t } = useTranslation();

  const {
    data: farmData,
    isLoading: farmIsLoading,
    isError: farmIsError,
  } = useSwrGet(
    `/farm/all`,
    process.env.NEXT_PUBLIC_BASE_URL +
      `farms/details/${authServices.userValue.org_id}/`
  );
  const {
    data: suppliers,
    isLoading: suppliersIsLoading,
    isError: suppliersIsError,
  } = useSwrGet(
    `/suppliers/all`,
    process.env.NEXT_PUBLIC_BASE_URL +
      `suppliers/?org_id__id=${authServices.userValue.org_id}`
  );
  function SubmitButton({ t, passProps, ...props }) {
    return (
      <Button
        title={t("Save & Continue")}
        className="w-full h-[35px] text-white rounded-lg bg-main  text-md mt-5"
        loading={props?.formState?.isSubmitting ?? false}
      />
    );
  }
  if (farmIsLoading || suppliersIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="flex flex-col w-80 ">
        <Input
          label={t("CameraCode")}
          name="camera_code"
          icon={() => (
            <p className="px-2 pt-4 text-sm font-bold outline-none appearance-none text-mako">
              {icon}
            </p>
          )}
          {...props}
        />
        <Select
          label={t("Select Farm")}
          name="farm_id"
          options={farmData?.map?.((farm) => ({
            label: farm.farm_name,
            value: farm.farm_id,
          }))}
          {...props}
        />
        <Select
          label={t("Select Field")}
          name="object_id"
          options={
            props.getValues().farm_id
              ? farmData
                  ?.filter?.(
                    (farm) => farm.farm_id == props.getValues().farm_id
                  )
                  ?.map?.((item) => item.fields)[0]
                  ?.map?.((item) => ({
                    label: item.field_name,
                    value: item.field_id,
                  }))
              : []
          }
          {...props}
        />

        <Select
          name="supplier_id"
          label={t("Supplier")}
          {...props}
          options={suppliers?.results?.map?.((user) => ({
            label: user.supplier_name,
            value: user.id,
          }))}
        />
        <Select
          name="camera_ownership"
          label={t("Ownership")}
          {...props}
          options={[
            { label: t("Owned"), value: "owned" },
            { label: t("Rented"), value: "rented" },
          ]}
        />
        <Textarea name="description" label={t("Description")} {...props} />

        <Input name="camera_model" label={t("Model")} {...props} />
        <Input name="camera_ip" label={t("IP")} {...props} />
        <Input name="access_link" label={t("Accesslink")} {...props} />
      </div>
      <SubmitButton t={t} passProps />
    </>
  );
}

export default cameraForm;
